import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map } from 'rxjs/operators';
import { openCSForList, openCSForPBasket } from '../actions';
import { activateConfigStrip } from '../actions/activate.actions';
import { ConfigStripActivationSource } from '../models';

@Injectable()
export class ConfigStripBackgroundProductsEffects {
  public prepareBackgroundProductsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(activateConfigStrip),
      filter(
        ({ source }) => source.source === ConfigStripActivationSource.List,
      ),
      map(() => openCSForList()),
    ),
  );

  public prepareBackgroundProductsSearch$ = createEffect(() =>
    this.actions$.pipe(
      ofType(activateConfigStrip),
      filter(
        ({ source }) => source.source === ConfigStripActivationSource.Search,
      ),
      map(() => openCSForPBasket()),
    ),
  );

  constructor(private actions$: Actions) {}
}
